/*=========================================
	++ common.js ++ Ver.1.6.1
	Last update 2020.9.10
==========================================*/
/*
* 2020  9/10 全体を一新
* 2019  5/ 7  *object-fit-images 追加
* 2018 11/20  *ブラウザ判定処理を一新
* 2018 10/25  *jQuery 3系 に対応

*/

'usestrict';


/*
 * rwdImageMaps jQuery plugin v1.6
 *
 * Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
 *
 * Copyright (c) 2016 Matt Stow
 * https://github.com/stowball/jQuery-rwdImageMaps
 * http://mattstow.com
 * Licensed under the MIT license
 */

;
(function ($) {
	$.fn.rwdImageMaps = function () {
		var $img = this;

		var rwdImageMap = function () {
			$img.each(function () {
				if (typeof ($(this).attr('usemap')) == 'undefined')
					return;

				var that = this,
					$that = $(that);

				// Since WebKit doesn't know the height until after the image has loaded, perform everything in an onload copy
				$('<img />').on('load', function () {
					var attrW = 'width',
						attrH = 'height',
						w = $that.attr(attrW),
						h = $that.attr(attrH);

					if (!w || !h) {
						var temp = new Image();
						temp.src = $that.attr('src');
						if (!w)
							w = temp.width;
						if (!h)
							h = temp.height;
					}

					var wPercent = $that.width() / 100,
						hPercent = $that.height() / 100,
						map = $that.attr('usemap').replace('#', ''),
						c = 'coords';

					$('map[name="' + map + '"]').find('area').each(function () {
						var $this = $(this);
						if (!$this.data(c))
							$this.data(c, $this.attr(c));

						var coords = $this.data(c).split(','),
							coordsPercent = new Array(coords.length);

						for (var i = 0; i < coordsPercent.length; ++i) {
							if (i % 2 === 0)
								coordsPercent[i] = parseInt(((coords[i] / w) * 100) * wPercent);
							else
								coordsPercent[i] = parseInt(((coords[i] / h) * 100) * hPercent);
						}
						$this.attr(c, coordsPercent.toString());
					});
				}).attr('src', $that.attr('src'));
			});
		};
		$(window).resize(rwdImageMap).trigger('resize');

		return this;
	};
})(jQuery);

//実行
$('.imagemap_responcive img[usemap]').rwdImageMaps();

//=====================================
//	Detecting Browser & Device Ver.1.4.2
//============================================

//++++++++++++ モバイル/タブレット/ブラウザ判定処理 ++++++++++++

//ブラウザ/デバイス 種別
var isMobile = false,
	isTablet = false,
	isRetina = false,
	isMobileTablet = false,
	isAndroid = false;

//モバイル　タブレット　判定
//https://w3g.jp/blog/js_browser_sniffing2015
var _ua = (function (u) {
	return {
		Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) |
			u.indexOf("blackberry") != -1
	};
})(window.navigator.userAgent.toLowerCase());

//モバイル
if (_ua.Mobile) {
	isMobile = true;
	isMobileTablet = true;
}
//タブレット
if (_ua.Tablet) {
	isTablet = true;
	isMobileTablet = true;
}

//Retina Display 判定
if (window.retina || window.devicePixelRatio > 1) {
	isRetina = true;
}

//Android 判定
if (/android[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
	isAndroid = true;
}




//============================================
//	デバイス　ブラウザ別の処理
//============================================

//++++++++++++ モバイル/タブレット クラス追加 ++++++++++++

$(function () {
	if (isMobile) {
		//HTMLにclass isMobileを追加
		$('html').addClass('isMobile');
		$('html').addClass('isMobileTablet');
	} else if (isTablet) {
		//HTMLにclass isTabletを追加
		$('html').addClass('isTablet');
		$('html').addClass('isMobileTablet');
	}
	//Retina Display isRetina クラス追加
	if (isRetina) {
		$('html').addClass('isRetina');
	}
});





//============================================
//	汎用スクリプト 
//============================================


//++++++ Copyright ++++++
// Copyright <span class="copyYear">&copy;</span>

$(function () {
	var date = new Date();
	var copyYear = date.getFullYear();
	copyYear = "&copy; "  + copyYear;
	$('.copyYear').html(copyYear);
});




//============================================
//	アンカーリンク　スクロール
//============================================

$(function () {

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	var nav_height = 80;
	if (window_width >= TABLET_WIDTH) {
		nav_height = 200;
	}


	var target_parm = '';
	var match = location.search.match(/target=(.*?)(&|$)/);
	if (match) {
		target_parm = decodeURIComponent(match[1]);
		target_parm = '#' + target_parm;
	}
	if (target_parm.length) {
		setTimeout(function () {
			var targetOffset = $(target_parm).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);
			return false;
		}, 500);
	}

});

//============================================
//	CSS カスタムプロパティー
//============================================

	//モバイルの画面高さを取得 (100vh 指定時のズレを調整)
	//CSS カスタムプロパティーに　innerHeigh を設定
$(function () {
	var height=window.innerHeight;
	document.documentElement.style.setProperty( '--innerheight', height/100 + 'px');

	var visual_width=$('.visual_ph_slider').width();
	document.documentElement.style.setProperty( '--visualwidth', visual_width + 'px');

	$(window).resize(function() {
		var height=window.innerHeight;
		document.documentElement.style.setProperty( '--innerheight', height/100 + 'px');

		var visual_width=$('.visual_ph_slider').width();
		document.documentElement.style.setProperty( '--visualwidth', visual_width + 'px');
	//	console.log(visual_width)
	});
});




//============================================
//	モバイル　ナビ
//============================================

$(function () {

	$('.js-mobile_navi').on('click', function () {

		if ($('.js-mobile_navi').hasClass('navi_active')) {

			$('.mobile_navi').addClass('navi_hide');
			$('.mobile_navi_bg').addClass('navi_bg_hide');
			$('body').removeClass('non_scroll');
			$('html').removeClass('non_scroll');
			$('.js-mobile_navi').removeClass('navi_active');
			$('.sp_header_login .acount_face').removeClass('acount_face_hide');
		} else {

			$('.mobile_navi').addClass('mobile_navi_slide');
			$('.mobile_navi').removeClass('navi_hide');
			$('.mobile_navi_bg').removeClass('navi_bg_hide');
			$('body').addClass('non_scroll');
			$('html').addClass('non_scroll');
			$('.js-mobile_navi').addClass('navi_active');
			$('.sp_header_login .acount_face').addClass('acount_face_hide');

		}

	});
});





//============================================
//	グローバルナビ　現在地
//============================================

$(function () {

	//URLを取得
	var my_path = location.pathname;


	//カテゴリごとの変数
	var is_home, is_nav1, is_nav2, is_nav3, is_nav4, is_nav5, is_nav6, is_nav7 = false;

	//@@@@@@ カテゴリごとのURL規則 @@@@@

	//*** nav1 ***/
	var regex_nav1 = /^\/concept\//i;

	//*** nav2***/
	var regex_nav2 = /^\/interview\//i;

	//*** nav3 ***/
	var regex_nav3 = /^\/how\//i;

	//*** nav4 ***/
	var regex_nav4 = /^\/works\//i;

	//*** nav5 ***/
	var regex_nav5 = /^\/help\//i;


	//*** HOME ***/
	//var regex_home = ($('body').attr('id') == 'root');
	var regex_home = ($('body').hasClass('Index'));


	//@@@@@@ 条件をテスト @@@@@@

	if (my_path.match(regex_nav1)) {
		is_nav1 = true;
	} else if (my_path.match(regex_nav2)) {
		is_nav2 = true;
	} else if (my_path.match(regex_nav3)) {
		is_nav3 = true;
	} else if (my_path.match(regex_nav4)) {
		is_nav4 = true;
	} else if (my_path.match(regex_nav5)) {
		is_nav5 = true;
	} else if (regex_home) {
		is_home = true;
	}


	//@@@@@@ 条件にあったら　.activeを追加　@@@@@@

	//クラス activeを追加
	if (is_home) {
		$('.gnav00').addClass('active');
	} else if (is_nav1) {
		$('.gnav01').addClass('active');
	} else if (is_nav2) {
		$('.gnav02').addClass('active');
	} else if (is_nav3) {
		$('.gnav03').addClass('active');
	} else if (is_nav4) {
		$('.gnav04').addClass('active');
	} else if (is_nav5) {
		$('.gnav05').addClass('active');
	}


});


//============================================
//	unit タブ切り替え
//============================================

$(function () {

	$('.tab_txt').on('click', function () {
		var target = $(this).attr('data-target');
		$(this).parents('.unit_tab').find('.tab_img').removeClass('tab_active');
		$(this).parents('.unit_tab').find('.tab_txt').removeClass('tab_active');
		$(this).parents('.unit_tab').find('.tab_caption').removeClass('tab_active');
		$(this).parents('.unit_tab').find(target).addClass('tab_active');
		$(this).addClass('tab_active');

	});
});

//AOS Active
$(function () {
	//AOS.init();
});



//============================================
//	検索 タブ切り替え
//============================================

$(function () {

	// PC タブ
	$('.search_tab_group a').on('click', function () {



		if ($('.search_tab_content').is(':hidden')) {
			$('.search_tab_content').show();
			$('.search_tab_group').removeClass('content_hidden')
		}

		var tareget=$(this).attr('data-group');
		$('.spot_category_list').hide();

		$('.spot_category_list').each(function(){
			var label=$(this).attr('data-group');
			if(tareget == label){
				$(this).fadeIn('fast');
			}
		});
		//ジャンルのValue を送信
		$('.js_genle_value').val(tareget);
	});

	// SP SELECT

	$('.js_genre_select').on('change', function () {

		var tareget=$(this).val();
		$('.spot_category_list').hide();

		$('.spot_category_list').each(function(){
			var label=$(this).attr('data-group');
			if(tareget == label){
				$(this).fadeIn('fast');
			}
		});
		//ジャンルのValue を送信
		$('.js_genle_value').val(tareget);
	});

	// SP SELECT オープン
	$('.js_btn_checkbox').on('click', function () {
		$('.search_Panel').fadeIn('fast');
	});

	// SP SELECT クローズ
	$('.js_search_close').on('click', function () {

		$('.search_Panel').fadeOut('fast');

	});


	// SP ICONS オープン
	$('.js_btn_genre').on('click', function () {
		$('.sp_genre_Panel').fadeIn('fast');
	});

	// SP ICONS クローズ
	$('.js_genre_close').on('click', function () {

		$('.sp_genre_Panel').fadeOut('fast');

	});




});


//++++++++ Header 検索窓 ++++++++
$(function () {
	$('.search_item_toggle').on('click', function () {
		$(".globalHeader_inner,.sp_header").toggleClass('search_active');
		

	})

});



//+++++++ MIGORO +++++++++

$(function () {

/*


	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;
	
	var nav_height = 80;

	//PC 書き込み用 DIV
	$('.migoro_list').append('<div class="migoro_right"></div>');


	if (window_width < TABLET_WIDTH) {
			$('.migoro_list_bar').removeClass('active');
			$('.migoro_list_bar').on('click', function () {
				$('.migoro_list_bar').not(this).removeClass('active');
				$(this).toggleClass('active');
				//$(this).addClass('active');
				$(this).parent('.migoro_list_box').find('.migoro_list_content').fadeToggle('fast');
				$('.migoro_list_bar').not(this).parent().find('.migoro_list_content').fadeOut('fast');
	
				$(this).parent('.migoro_list_box').find('.migoro_list_content').addClass('migoro_list_show');
				$('.migoro_list_bar').not(this).parent().find('.migoro_list_content').removeClass('migoro_list_show');
			})
	}else{


		var start_html = $('.migoro_list_content').eq(0).html();
			start_html = '<div class="migoro_list_content migoro_list_show">'+start_html+'</div>';
			$('.migoro_right').html(start_html);
			$('.migoro_list_bar').on('click', function () {

				$('.migoro_list_bar').removeClass('active');
				$(this).addClass('active');

				var migoro_html = $(this).parent().find('.migoro_list_content').html();
					migoro_html = '<div class="migoro_list_content migoro_list_show">'+migoro_html+'</div>';
					$('.migoro_right').html(migoro_html);

			});

	}

*/



var TABLET_WIDTH = 768;
//ウィンドウ幅
var window_width = window.innerWidth;

var nav_height = 80;
if (window_width >= TABLET_WIDTH) {
	nav_height = 200;
}

//PC 書き込み用 DIV
$('.migoro_list').append('<div class="migoro_right"></div>');


if (window_width < TABLET_WIDTH) {
		$('.migoro_list_bar').removeClass('active');

		$('.migoro_list_bar').on('click', function () {
			$('.migoro_list_bar').not(this).removeClass('active');
			$(this).toggleClass('active');
			//$(this).addClass('active');
			$(this).parent('.migoro_list_box').find('.migoro_list_content').fadeToggle('fast');
			$('.migoro_list_bar').not(this).parent().find('.migoro_list_content').fadeOut('fast');

			$(this).parent('.migoro_list_box').find('.migoro_list_content').addClass('migoro_list_show');
			$('.migoro_list_bar').not(this).parent().find('.migoro_list_content').removeClass('migoro_list_show');
		});

		$('.migiro_number_navi_item a').on('click', function () {
			var target=$(this).attr('data-goto');
			$('.migoro_list_bar').removeClass('active');
			$(target).find('.migoro_list_bar').addClass('active');
			$('.migoro_list_content').fadeOut('fast');
			$(target).find('.migoro_list_content').fadeToggle('fast');





			var position = $(target).offset().top - nav_height;

			setTimeout(function () {
				$("html,body").animate({
					scrollTop : position
				}, {
					queue : false
				});
			}, 900);

		});

}else{


	var start_html = $('.migoro_list_content').eq(0).html();
		start_html = '<div class="migoro_list_content migoro_list_show">'+start_html+'</div>';
		$('.migoro_right').html(start_html);
		$('.migoro_list_bar').on('click', function () {

			$('.migoro_list_bar').removeClass('active');
			$(this).addClass('active');

			var migoro_html = $(this).parent().find('.migoro_list_content').html();
				migoro_html = '<div class="migoro_list_content migoro_list_show">'+migoro_html+'</div>';
				$('.migoro_right').html(migoro_html);

		});

		$('.migiro_number_navi_item a').on('click', function () {
			var target=$(this).attr('data-goto');

			$('.migoro_list_bar').removeClass('active');
			$(target).find('.migoro_list_bar').addClass('active');

			var migoro_html = $(target).find('.migoro_list_content').html();
				migoro_html = '<div class="migoro_list_content migoro_list_show">'+migoro_html+'</div>';
				$('.migoro_right').html(migoro_html);
				
				var position = $("#migoro_list").offset().top - nav_height;
				$("html,body").animate({
					scrollTop : position
				}, {
					queue : false
				});


		});

}


});


//++++++ フォトギャラリー ++++++

$(function () {

	$('.photo_gallery_box').on('click', function () {

		
		var  image_url= $(this).attr('data-image');
		var caption = $(this).find('.photo_gallery_box_caption').text();
		var down_url = $(this).attr('data-download');
		var img_style ='background-image: url('+image_url+');';

		$('.gallery_overlay_image_canvas_inner').attr('style',img_style);
		$('.gallery_caption').text(caption);
		$('.gallery_down a').attr('href',down_url);

		$('.gallery_overlay').fadeIn('fast');
	});


	$('.gallery_overlay').on('click', function () {
		$('.gallery_overlay').fadeOut('fast');

	});

	$('.gallery_window_wrap_inner').click(function (event) {
		event.stopPropagation();
	});

});



//============================================
//	TOP スライダー高さ調整
//============================================
$(function () {

	var tokusyu_height = new Array();
	

	//if ($('body').hasClass('Index')) {

		$(".idx_tokusyu_slider .unit_list_box").each(function (idx) {
			//高さを追加					   
			tokusyu_height[idx] = $(this).height();
		});

		var maxH = Math.max.apply(null, tokusyu_height);

		$(".idx_tokusyu_slider .unit_list_box").css({
			"height": maxH + "px"
		});

	

	//}


});


